<div class="card-content">
    <div class="card-box-medium margin-right-small" (keydown)="keyDownFunction($event)">
        <br />
        <br />
        <!--<mat-divider></mat-divider>-->

        <form [formGroup]="questionFormGroup">
            <div class="question-card">
                <p *ngIf="questionsFinish" class="patient-question">Condiciones finalizadas</p>
                <p class="patient-question-block" *ngIf="questionsFinish">{{blockMessage}}</p>
                <p *ngIf="!questionsFinish" class="patient-question">{{getCurrentQuestion().PatientQuestion}}</p>

                <mat-form-field *ngIf="getCurrentQuestion().LoadValue && !questionsFinish" class="question-card">
                    <input matInput type="number" [appAutofocus]="( focus === 'questionValue' )" formControlName="questionValue" placeholder="{{getCurrentQuestion().PatientQuestion}}" required>
                </mat-form-field>

                <mat-form-field *ngIf="getCurrentQuestion().LoadObservation && !questionsFinish" class="question-card">
                    <textarea matInput formControlName="questionObservations" placeholder="Observaciones"></textarea>
                </mat-form-field>


                <button type="button" *ngIf="!getCurrentQuestion().LoadValue && !questionsFinish" #buttonQuestionYes (click)="questionYes()" mat-button>Sí</button>
                <button type="button" *ngIf="!getCurrentQuestion().LoadValue && !questionsFinish" (click)="questionNo()" mat-button>No</button>
                <button type="button" *ngIf="getCurrentQuestion().LoadValue && !questionsFinish" (click)="questionAccept()" mat-button>Aceptar</button>
            </div>
        </form>
    </div>
    <div class="card-box-medium" (keydown)="keyDownFunction($event)">
        <div class="card-inline">
            <h4>Respuestas</h4>
        </div>
        <div class="card-inline">
            <button type="button" (click)="redo()" mat-mini-fab>
        <mat-icon>redo</mat-icon>
      </button>
        </div>
        <mat-divider></mat-divider>
        <table mat-table class="question-table" *ngIf="reservationQuestion.Answers.length > 0" [dataSource]="patientAnswersDataSource">
            <tr mat-header-row class="table-header" *matHeaderRowDef="displayAnswersColumns"></tr>
            <tr mat-row class="table-cell" *matRowDef="let row; let i = index; columns: displayAnswersColumns;"></tr>
            <ng-container matColumnDef="PatientQuestion">
                <th mat-header-cell class="table-header" *matHeaderCellDef> Pregunta </th>
                <td mat-cell class="table-cell" *matCellDef="let element"> {{element.PatientQuestion}} </td>
            </ng-container>
            <ng-container matColumnDef="Answer">
                <th mat-header-cell class="table-header" *matHeaderCellDef> Respuesta </th>
                <td mat-cell class="table-cell" *matCellDef="let element"> {{element.Answer}} </td>
            </ng-container>
        </table>
    </div>
</div>
<div class="clearfix">
    <div class="pull-right margin-top-medium margin-right-medium">
        <button class="card-inline" type="button" mat-button>CANCELAR</button>
    </div>
    <div class="card-footer margin-top-medium">
        <button mat-button color="primary" matStepperPrevious>ANTERIOR</button>
        <button color="primary" mat-flat-button matStepperNext type="submit">SIGUIENTE</button>
    </div>
</div>